import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "./common/Header";
import Footer from "./common/Footer";
import traderegistrationbg from "../images/trade-registration-bg.png";
import { callApi } from "./common/API/Api";
import { useTranslation } from "react-i18next";
import { showProcessToast, updateToastMessage } from "./common/Tostify";
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";
import { getBaseUrl } from "./common/BaseUrl";
const Contacts = () => {
   const token = localStorage.getItem("token");
  let base_url = getBaseUrl()
  function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
     ;
    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = (e) => setMatches(e.matches);
      mql.addEventListener("change", handler);
      setMatches(mql.matches);
      return () => mql.removeEventListener("change", handler);
    }, [query]);
    return matches;
  }

  const isDesktop = useMediaQuery("(min-width: 1402px)");
  const wrapperRef = useRef(null);
  const { t } = useTranslation();
  const [scrollTop, setScrollTop] = useState(0);
  const [contactspagedata, setContactspagedata] = useState();
  const [loading, setLoading] = useState(false);
  const [contentdata, setContentdata] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });
  const [validmessage, setValidmessage] = useState();
  const location = useLocation();
  const canonicalURL = `https://equlix.com${location.pathname}`;
  useEffect(() => {
    if (!isDesktop) return;
    const handleScroll = () => {
      setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
    };

    const handleResize = () => {
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      }
    };
    if (wrapperRef.current) {
      document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      document.body.style.overflow = "auto";

      wrapperRef.current.style.transition = "transform 0.3s ease-out";
      wrapperRef.current.style.position = "fixed";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.left = "0";
      wrapperRef.current.style.width = "100%";
      wrapperRef.current.style.padding = "0";
      wrapperRef.current.style.zIndex = "2";
      wrapperRef.current.style.display = "block";
      wrapperRef.current.style.backfaceVisibility = "hidden";
    }
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, wrapperRef?.current?.offsetHeight]);
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
    }
  }, [scrollTop]);
  useEffect(() => {
    document.body.style.backgroundColor = "#000000";
    return () => {
      document.body.style = {};
    };
  }, []);
  const aboutpagecontent = useCallback(async ()=>{
 try {
   let langcode = base_url.split("/")[1]
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/get-contact-us-page?lang=${langcode}`,
        "GET",
      );
      if (res?.data?.success) {
        setContactspagedata({ ...res?.data?.data, ...res?.data?.contact_data });
      }
    } catch (err) {
      console.log(err, "err");
    }
  },[base_url])

  useEffect(() => {
    aboutpagecontent();
  }, [aboutpagecontent]);
  const BreakText = ({ text, breakAt }) => {
    const splitText = (text, breakAt) => {
      if (!text) return;
      const words = text?.split(" ");
      const beforeBreak = words.slice(0, breakAt)?.join(" ");
      const afterBreak = words.slice(breakAt)?.join(" ");
      return (
        <>
          {beforeBreak}
          <br />
          {afterBreak}
        </>
      );
    };

    return splitText(text, breakAt);
  };
  const onchangedata = (key, value) => {
    setContentdata((state) => ({
      ...state,
      [key]: value,
    }));
  };
  const fromvalidaction = (contentdata) => {
    let valid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let validdata = {};
    if (!contentdata?.name) {
      validdata.name = "Name is Required";
      valid = false;
    }
    if (!contentdata?.number) {
      validdata.number = "Phone Number is Required";
      valid = false;
    }
    if (!contentdata?.email) {
      validdata.email = "Email is Required";
      valid = false;
    } else if (!emailRegex.test(contentdata?.email)) {
      validdata.email = "Please enter a valid email address.";
      valid = false;
    }
    if (!contentdata?.message) {
      validdata.message = "Message is Required";
      valid = false;
    }
    setValidmessage(validdata);
    return valid;
  };
  const contentfrom = async (contentdata) => {
    if (fromvalidaction(contentdata)) {
      try {
        const processToastId = showProcessToast("Loading data... Please wait.");
        setLoading(true);
        let postdata = contentdata;
        let res = await callApi(postdata, `api/contact`, "POST");
        if (res?.data?.success) {
          updateToastMessage(processToastId, res?.data?.message, "success");
          setContentdata({
            name: "",
            email: "",
            number: "",
            message: "",
          });
        } else {
          updateToastMessage(processToastId, res?.data?.message, "error");
        }
      } catch (err) {
        console.log(err, "err");
      } finally {
        setLoading(false);
      }
    }
  };

  // useEffect(() => {
  //   if (contactspagedata?.meta?.meta_title) {
  //     document.title = contactspagedata?.meta?.meta_title || "Equlix";

  //     const descriptionMeta = document.querySelector(
  //       "meta[name='description']"
  //     );
  //     if (descriptionMeta) {
  //       descriptionMeta.setAttribute(
  //         "content",
  //         contactspagedata?.meta?.meta_description || ""
  //       );
  //     } else {
  //       const meta = document.createElement("meta");
  //       meta.name = "description";
  //       meta.content = contactspagedata?.meta?.meta_description || "";
  //       document.head.appendChild(meta);
  //     }

  //     const keywordsMeta = document.querySelector("meta[name='keywords']");
  //     if (keywordsMeta) {
  //       keywordsMeta.setAttribute(
  //         "content",
  //         contactspagedata?.meta?.meta_keywords || ""
  //       );
  //     } else {
  //       const meta = document.createElement("meta");
  //       meta.name = "keywords";
  //       meta.content = contactspagedata?.meta.meta_keywords || "";
  //       document.head.appendChild(meta);
  //     }
  //   } else {
  //     document.title = "Equlix";
  //   }
  // }, [contactspagedata]);

  return (
    <div className="home">
      <Helmet>
        <title>{contactspagedata?.meta?.meta_title || "Equlix"}</title>

        <meta
          name="description"
          content={contactspagedata?.meta?.meta_description || "About Equlix"}
        />
        <meta
          name="keywords"
          content={
            contactspagedata?.meta?.meta_keywords || "Equlix Trading Platform"
          }
        />
        <link rel="canonical" href={canonicalURL} />
      </Helmet>
      <div className="main-page" ref={wrapperRef}>
        <Header />
        <section
          class="trade_demo_sec contactpage"
          style={{ backgroundImage: `url(${traderegistrationbg})` }}
        >
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="sec_title text-center">
                  <h2 class="block_title">{contactspagedata?.title?.title}</h2>
                </div>
              </div>
            </div>
            <div class="row contact_dt_row">
              <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="contact_col">
                  <div class="sec_title">
                    <h3 class="col_title">
                      {contactspagedata?.subtitle?.subtitle}
                    </h3>
                    <p>{contactspagedata?.description?.description}</p>
                  </div>
                  <form action="#" class="contact_form">
                    <div class="row">
                      <div class="form-group mb-3 col-lg-6 col-md-6 col-sm-12">
                        <input
                          onChange={(e) => {
                            onchangedata("name", e.target.value);
                          }}
                          value={contentdata?.name}
                          type="text"
                          class="form-control"
                          id="exampleInputname"
                          aria-describedby="name"
                          placeholder="Your name *"
                          required=""
                        />
                        {validmessage?.name && (
                          <p className="text-danger">{validmessage?.name}</p>
                        )}
                      </div>
                      <div class="form-group mb-3 col-lg-6 col-md-6 col-sm-12">
                        <input
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 15 && /^\d*$/.test(value)) {
                              onchangedata("number", value);
                            }
                          }}
                          value={contentdata?.number}
                          type="text"
                          class="form-control"
                          id="exampleInputnumber"
                          aria-describedby="numberHelp"
                          placeholder="Your number *"
                          required=""
                        />
                        {validmessage?.number && (
                          <p className="text-danger">{validmessage?.number}</p>
                        )}
                      </div>
                      <div class="form-group mb-3 col-lg-12 col-md-12 col-sm-12">
                        <input
                          onChange={(e) => {
                            onchangedata("email", e.target.value);
                          }}
                          value={contentdata?.email}
                          type="email"
                          class="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Email address *"
                          required=""
                        />
                        {validmessage?.email && (
                          <p className="text-danger">{validmessage?.email}</p>
                        )}
                      </div>
                      <div class="form-group mb-3 col-lg-12 col-md-12 col-sm-12">
                        <textarea
                          onChange={(e) => {
                            onchangedata("message", e.target.value);
                          }}
                          value={contentdata?.message}
                          id="message"
                          class="form-control"
                          name="message"
                          rows="4"
                          placeholder="Message *"
                        ></textarea>
                        {validmessage?.message && (
                          <p className="text-danger">{validmessage?.message}</p>
                        )}
                      </div>
                      <div class="form-btn col-12">
                        {loading ? (
                          <button type="button" className="btn site_grdbtn">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>{" "}
                          </button>
                        ) : (
                          <div
                            type="submit"
                            class="btn site_grdbtn"
                            onClick={() => contentfrom(contentdata)}
                          >
                            {t("Send")}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <ul class="footer_menu_links contactDtl">
                  <li className="list021">
                    <h5><i class="fa-solid fa-headset"></i> Support Service</h5>
                    <p>Equlix support specialists are happy to answer any questions you may have via built-in:</p>
                    <Link className="contactlink"
                     to={
                          token
                            ? `${base_url}supportdashboard`
                            : `${base_url}login`
                        }
                         state={token ? { from: "my_requests" } : ""}>Support Desk</Link>
                  </li>
                  <li>{contactspagedata?.content?.email}</li>
                  <li>{contactspagedata?.content?.phone}</li>
                  <li>
                    <BreakText
                      text={contactspagedata?.content?.address}
                      breakAt={2}
                    />
                  </li>
                </ul>
                <div className="social-link">
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.twitter.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-x-twitter"></i>
                  </a>
                </div>  
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default Contacts;
